import React from 'react';
import { Row } from 'reactstrap';
import { SortableContainer } from 'react-sortable-hoc';

import AddLotImage from './AddLotImage';

// First map all existing images, then newly uploaded images
const SortableImageContainer = SortableContainer(
  ({ handleDeleteFile, lotImages, lotImageKeys, maxSeqNumber }) => (
    <Row>
      {lotImageKeys.map(item => (
        <AddLotImage
          handleDeleteFile={handleDeleteFile}
          imageUploaded={true}
          imageUploadedSrc={lotImages[item]}
          index={parseInt(item, 10)}
          key={parseInt(item, 10)}
          maxSeqNumber={maxSeqNumber}
        />
      ))}
    </Row>
  )
);
export default SortableImageContainer;
